<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height: 190px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .bar {
    width: 100%;
    height: 190px;

    .main {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="table">
      <div class="bar">
        <div class="main"></div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from '../common/boxWrap';
import bar from 'components/dashboard/bar'
import echarts from "echarts";
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  // props: ["salesData", "salesDataBar"],
  data() {
    return {
      name: '收支公开',
      dataY: [],
      dataX: [],
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide,
    bar
  },
  methods: {
    init() {
      window.addEventListener(
        "resize",
        function () {
          this.myChart.resize();
        }.bind(this)
      );
    },
    getData() {
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.clear()
      this.chart();
    },
    chart() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.querySelector(".bar .main"));
      this.myChart.setOption({
        "tooltip": {
          "trigger": "axis",
          "axisPointer": {
            "type": "shadow",
            textStyle: {
              color: "#fff"
            }
          }
        },
        grid: {
          top: '15%',
          left: '3%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        "legend": {
          x: '40%',
          top: '2%',
          textStyle: {
            color: '#FFF'
          },
          itemHeight: 4,
          itemWidth: 14,
          "data": ['收入', '支出']
        },
        "xAxis": [{
          "type": "category",
          axisLine: {
            lineStyle: {
              color: "#0177d4"
            }
          },
          "splitLine": {
            "show": false
          },
          "axisTick": {
            "show": false
          },
          "splitArea": {
            "show": false
          },
          axisLabel: {
            interval: 0,
            color: "#fff",
            fontSize: 12
          },
          "data": [2012, 2013, 2014, 2015, 2016, 2017]
        }],
        "yAxis": [{
          name: '百万',
          nameTextStyle: {
            color: "#fff",
            fontSize: 12,
            padding: [25, 0, 0, -20]
          },
          "type": "value",
          "splitLine": {
            "show": false
          },
          "axisLine": {
            lineStyle: {
              color: "#0177d4"
            }
          },
          "axisTick": {
            "show": false
          },
          "axisLabel": {
            "interval": 0

          },
          "splitArea": {
            "show": false
          },
          axisLabel: {
            interval: 0,
            color: "#fff",
            fontSize: 12
          }
        }],
        "series": [{
          "name": "收入",
          "type": "bar",
          "stack": "总量",
          "barMaxWidth": 20,
          "barGap": "10%",
          "itemStyle": {
            "normal": {
              "color": "#76CD2E",
              "label": {
                "show": false,
                "textStyle": {
                  "color": "#fff"
                },
                "position": "insideTop"
                // formatter: function (p) {
                //   return p.value > 0 ? (p.value) : '';
                // }
              }
            }
          },
          "data": [
            80,
            60,
            50,
            60,
            100,
            110
          ]
        },
        {
          "name": "支出",
          "type": "bar",
          "stack": "总量",
          "itemStyle": {
            "normal": {
              "color": "#486FF1",
              "barBorderRadius": 0,
              "label": {
                "show": false,
                "position": "top"
                // formatter: function (p) {
                //   return p.value > 0 ? (p.value) : '';
                // }
              }
            }
          },
          "data": [
            10,
            10,
            20,
            30,
            40,
            40
          ]
        }
        ]
      });

      const that = this;
      let index = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        // console.log(index)
        if (index >= 6) {
          index = 0;
        }
      }, 3000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    // this.tableData = this.salesData
    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
    // var myDate = new Date();
    // myDate.setDate(myDate.getDate() - 7);
    // var dateArray = []
    // var dateTemp;
    // var flag = 1;
    // for (var i = 0; i < time.length; i++) {
    //   let day = myDate.getDate() + i + 1;
    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
    //   this.dataY.push(this.salesDataBar[0][time[i]])
    //   this.dataX.push(dateTemp)
    // }

    this.dataY = [80, 50, 60, 100, 150, 120]
    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
    var self = this;
    self.chart();
    self.init();
    // this.timer = setInterval(() => {
    //   self.getData()
    // }, 3000);
  }
}

</script>


// WEBPACK FOOTER //
// index.vue?d60d06a6